import Request from './request'

const Utilities = {
  getUtilities (callback) {
    Request.get('utility/get-actions').then(callback).catch(this.bad_answer)
  },
  getConsoleCommandCatalog (params, callback, bad_answer) {
    Request.get('console-command-catalog/index?' + new URLSearchParams(params).toString()).then(callback).catch(bad_answer)
  },
  getConsoleCommandRuns (params, callback, bad_answer) {
    Request.get('console-command-run/index', params).then(callback).catch(bad_answer)
  },
}
export default Utilities
